export const colors = {
  WHITE: "#fff",
  MERCURY: "#e8e8e8",
  BONDI_BLUE: "#0099bc",
  PATTENS_BLUE: "#dceaff",
};
